/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { useMutation, useQuery } from 'react-query';

import {
  changeAccountAlias,
  getAccounts,
  getBalancesExport,
  getBalancesExportCheck,
  getBalancesExportStatus,
  getLimits,
} from '~/api/accounts';
import { Account, ExportStatus } from '~/types';
import { usePageQuery } from '~/hooks/usePageQuery';
import { queryClient } from '~/index';

export const useAccountsQuery = () => {
  return useQuery(['accounts'], () => getAccounts().then((res) => res.data));
};

// accountsByPage -- temporary key; when useAccountsQuery is completely deleted, you can use just 'accounts'
const accountsByPageKey = 'accountsByPage';
export const useAccountsPageQuery = (options?: any) => {
  return usePageQuery<Account[]>(accountsByPageKey, getAccounts, options);
};
export const invalidateAccountsPageQuery = () => {
  void queryClient.invalidateQueries(accountsByPageKey);
};

export const useAccountsByIdsQuery = (ids: string[], options?: any) => {
  return useQuery(['accountsByIds', ...ids], () => getAccounts({ ids: ids }), {
    enabled: ids?.length > 0,
    ...options,
  });
};

export const useChangeAccountAlias = (reloadAccounts: () => void) => {
  return useMutation(changeAccountAlias, {
    onSuccess: () => {
      reloadAccounts();
    },
  });
};

export const useAccountLimitsQuery = (accountId: string | undefined) => {
  return useQuery(
    ['accounts', accountId, 'limits'],
    () => getLimits(accountId!)().then((res) => res.data),
    {
      enabled: !!accountId,
    }
  );
};

export const useBalancesExportCheck = () => {
  return useQuery(['balancesExportCheck'], getBalancesExportCheck);
};

export const useBalancesExportStatus = (exportId: string | null) => {
  return useQuery<ExportStatus>(
    ['exportStatus', exportId],
    exportId ? () => getBalancesExportStatus(exportId) : () => Promise.resolve(),
    { enabled: !!exportId, refetchInterval: 2000 }
  );
};

export const useCreateBalancesExportTask = () => {
  return useMutation(getBalancesExport);
};
